import { Image, Music, Code2, MessageSquare, LayoutDashboard, History } from 'lucide-react';

export const NAV_ITEMS = [
  { to: '/app', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/app/image', label: 'Image', icon: Image },
  { to: '/app/music', label: 'Music', icon: Music },
  { to: '/app/code', label: 'Code', icon: Code2 },
  { to: '/app/chat', label: 'Chat', icon: MessageSquare },
  { to: '/app/history', label: 'History', icon: History },
];

/** Display-only tier metadata. Server enforces the real limits. */
export const TIERS = [
  {
    id: 'FREE',
    name: 'Free',
    price: 0,
    tagline: 'Explore the studio',
    features: [
      '30 generations / month',
      'All open-source models',
      'Image, music & code studios',
      'Claude chat (basic)',
      '7-day history',
    ],
    cta: 'Start free',
    highlighted: false,
  },
  {
    id: 'PRO',
    name: 'Pro',
    price: 18,
    tagline: 'For serious creators',
    features: [
      '1,000 generations / month',
      'Priority queue',
      'Full history + export',
      'Voice input & TTS',
      'Pin & organize outputs',
    ],
    cta: 'Upgrade to Pro',
    highlighted: true,
  },
  {
    id: 'TEAM',
    name: 'Team',
    price: 49,
    tagline: 'Create together',
    features: [
      '5,000 generations / month',
      'Up to 5 seats',
      'Shared workspace history',
      'Priority support',
      'Early access features',
    ],
    cta: 'Upgrade to Team',
    highlighted: false,
  },
];

export const MODALITY_META = {
  IMAGE: { label: 'Image', color: 'brand', accent: '#6d5efc' },
  MUSIC: { label: 'Music', color: 'cyan', accent: '#34e7e4' },
  CODE: { label: 'Code', color: 'fuchsia', accent: '#e85bff' },
  CHAT: { label: 'Chat', color: 'amber', accent: '#ffb454' },
};
